import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BlueBookTooltip from 'chameleon/packages/blue-book-player/library/tooltip/BlueBookTooltip';

const MenuItemWrapperTooltip = ({
  withTooltip,
  toolTipId,
  toolTipDescription,
  children,
}) => {
  const [wasUsed, setWasUsed] = useState(false);
  if (withTooltip && !wasUsed) {
    const onVisibleChange = (tooltipEl, isVisible) => {
      if (!isVisible) {
        setWasUsed(true);
      }
    };

    const onMouseLeave = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    const onContainerClick = () => {
      setWasUsed(true);
    };

    return (
      <BlueBookTooltip
        defaultVisible
        renderInBody
        onButtonPress
        closeOnOutsideClick
        interactive={false}
        tooltipProps={{
          id: `menu-item-tooltip-${toolTipId}`,
          onMouseLeave,
        }}
        description={toolTipDescription}
        onVisibleChange={onVisibleChange}
        onContainerClick={onContainerClick}
      >
        {children}
      </BlueBookTooltip>
    );
  }
  return children;
};

MenuItemWrapperTooltip.propTypes = {
  withTooltip: PropTypes.bool,
  toolTipId: PropTypes.string,
  toolTipDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

MenuItemWrapperTooltip.defaultProps = {
  withTooltip: true,
  toolTipId: null,
  toolTipDescription: null,
};

export default MenuItemWrapperTooltip;
